import {ComponentRef, Input, OnDestroy, Output, EventEmitter, Component} from '@angular/core';

import {Form, Question} from './smartform.interface';

@Component({
	selector: 'prop-base',
	template: '<div></div>',
})
export class Core implements OnDestroy {
	@Input()
	question: Question;
	defaultValue: any;
	@Input()
	disabled: boolean = false;
	@Input()
	condition: boolean = false;
	@Output()
	loadComplete: EventEmitter<any> = new EventEmitter();
	public form: Form;
	public smartForm: any;
	_removeRef: ComponentRef<any>;

	constructor() {}

	updateTools(tools) {
		this.question.tools = tools;
	}

	// Used for label colour
	getStyle() {
		// If question is not valid show error colour
		if (this.question !== undefined) {
			if (!this.question.valid) {
				return 'item-text-wrap text-danger';
			} else {
				return 'item-text-wrap';
			}
		}
	}

	disable(d) {
		if (d === undefined) {
			d = true;
		}
		this.disabled = d;
	}

	ngOnViewInit() {
		if (this.question.disabled != undefined) {
			this.disabled = this.question.disabled;
		}
	}

	// Check if is numeric
	isNumeric(n: any) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	}

	isTool() {
		if (this.question !== undefined) {
			if (this.form !== undefined && this.form.complete) {
				return true;
			} else {
				if (this.question.isTool == true) {
					return false;
				} else {
					return true;
				}
			}
		}
	}

	hasTool() {
		if (this.question !== undefined) {
			if (this.form !== undefined && this.form.complete) {
				return true;
			} else {
				if (this.question.tool == true) {
					return false;
				} else {
					return true;
				}
			}
		} else {
			return true;
		}
	}

	hasDate() {
		return (
			this.Android() ||
			this.BlackBerry() ||
			this.iOS() ||
			this.Opera() ||
			this.Windows()
		);
	}

	Android() {
		return navigator.userAgent.match(/Android/i);
	}

	BlackBerry() {
		return navigator.userAgent.match(/BlackBerry/i);
	}

	iOS() {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	}

	Opera() {
		return navigator.userAgent.match(/Opera Mini/i);
	}

	Windows() {
		return navigator.userAgent.match(/IEMobile/i);
	}

	Safari() {
		return navigator.userAgent.match(/Safari/i);
	}

	ngOnDestroy() {
		this.defaultValue = void 0;
		this.disabled = void 0;
		this.condition = void 0;
		this.form = void 0;
		this.smartForm = void 0;
		this._removeRef = void 0;
	}
}
